<template>
  <!-- 步骤条组件 -->
  <div class="step-container">
    <!-- 问题反馈 -->
    <div class="main-box">
      <!-- 左边区域 -->
      <div class="left-line">
        <div class="img">
          <img class=""
               :src="step_img" />
        </div>
        <!-- 竖向虚线 -->
        <div class="dashed-line"></div>
      </div>
      <!-- 右边区域 -->
      <div class="right-text">
        <div class="tip">{{dataList[0].createTime}} 问题反馈</div>
        <div class="problem">
          <div class="problem-title" v-if="dataList[0].title != 'undefined' && flag != 'governance'">{{dataList[0].title}}</div>
          <div class="problem-content" style="padding-top: 20px;">{{dataList[0].content}}</div>
          <div class="image-list">
            <div class="image-box"
                 v-for="item in dataList[0].pictures">
              <el-image class="el_img"
                        :preview-src-list="srcList"
                        @click="showImg(dataList[0].pictures)"
                        fit="fill"
                        :src="item">
              </el-image>
            </div>
          </div>
          <div class="video-title" v-if="dataList[0].videos && dataList[0].videos.length > 0">相关视频：</div>
          <div class="video-box" v-if="dataList[0].videos && dataList[0].videos.length > 0">
            <video :src="dataList[0].videos[0]"
                   controls></video>
          </div>
        </div>
      </div>
    </div>
    <!-- 待处理 -->
    <div class="main-box">
      <!-- 左边区域 -->
      <div class="left-line">
        <div class="img">
          <img class=""
               :src="step_img" />
        </div>
        <!-- 竖向虚线 -->
        <div class="dashed-line"></div>
      </div>
      <!-- 右边区域 -->
      <div class="right-text">
        <div class="tip">{{dataList[0].createTime}} 待处理</div>
        <div class="problem">
          <div class="problem-content"
               style="padding: 25px 0" >
            您的问题已经审核，正在等待处理。
          </div>
        </div>
      </div>
    </div>
    <!-- 处理结果 -->
    <div class="main-box" v-if="dataList[0].processingStatus === '1'">
      <!-- 左边区域 -->
      <div class="left-line">
        <div class="img">
          <img class=""
               :src="step_img" />
        </div>
        <!-- 竖向虚线 -->
        <div class="dashed-line"></div>
      </div>
      <!-- 右边区域 -->
      <div class="right-text">
        <div class="tip">{{dataList[0].updateTime}} 处理结果</div>
        <div class="problem">
          <div class="problem-content"
               style="padding: 25px 0">{{dataList[0].processingResults}}</div>
          <div class="image-list" >
            <div class="image-box"
                 v-for="(item,index) in dataList[0].processingImgs" :key="index">
              <el-image class="el_img"
                        :preview-src-list="srcList"
                        @click="showImg(dataList[0].processingImgs)"
                        fit="fill"
                        :src="item">
              </el-image>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StepDetail",
  props: ["dataList", "flag"],

  mounted() {
    console.log(this.dataList[0].title != 'undefined' && this.flag != 'governance');
    console.log(this.dataList[0].title != 'undefined' && this.flag != 'governance');
  },
  data() {
    return {
      step_img: require("@/assets/images/step.png"),
      test_img: require("@/assets/images/banner.jpg"),
      srcList: [],
    };
  },
  methods: {
    // 预览大图 表格里
    showImg(url) {
      if (url.length > 0) {
        this.srcList = url;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.main-box {
  display: flex;
  height: 100%;
  margin-bottom: 36px;
}

.main-box:last-child {
  margin-bottom: 0;
  overflow: hidden;
}

.main-box .left-line {
  width: 60px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.main-box .left-line .img {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 25px;
}

.main-box .left-line image {
  width: 35px;
  height: 35px;
}

.main-box .left-line .dashed-line {
  height: 100%;
  border: 1px dashed #41c46c;
}

.main-box .right-text {
  width: 100%;
  padding: 0 10px;
}

.main-box .right-text .tip {
  margin-bottom: 15px;
  color: #ffffff;
  font-size: 20px;
}

.main-box .right-text .problem {
  box-sizing: border-box;
  width: 100%;
  background: #104853;
  border-radius: 8px;
  border: 1px solid #008f82;
  padding: 0 12px;
}

.main-box .right-text .problem .problem-title {
  text-align: center;
  font-size: 18px;
  color: #ffffff;
  padding-top: 28px;
  padding-bottom: 21px;
}

.video-title {
  font-size: 18px;
  color: #3ef89c;
  margin-bottom: 30px;
}

.main-box .right-text .problem .problem-content {
  color: #ffffff;
  font-size: 16px;
  text-align: justify;
  padding-bottom: 25px;
}

.main-box .right-text .problem .image-list,
.video-box {
  display: flex;
  justify-content: flex-start;
}

.main-box .right-text .problem .image-list .image-box {
  display: flex;
  width: 18%;
  height: 121px;
  border-radius: 16px;
  margin-right: 8px;
  overflow: hidden;
  margin-bottom: 30px;
}

.main-box .right-text .problem .image-list .image-box .el_img {
  width: 100%;
  height: 100%;
}

.main-box .right-text .problem .video-box {
  width: 50%;
  height: 250px;
  border-radius: 10px;
  margin-right: 8px;
  padding: 10px;
  margin-bottom: 30px;
  overflow: hidden;
  border: 1px dashed #3ef89c;
}

.main-box .right-text .problem .image-list .image-box:last-child,
.video-box:last-child {
  margin-right: 0;
}

.main-box .right-text .problem .image-list .image-box image {
  width: 100%;
  height: 100%;
}

.main-box .right-text .problem .video-box video {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/rightAside/detail_cjt/step_component/step_detail.vue